import { BehaviorSubject, Subject } from 'rxjs';

export abstract class AbstractSearchService<T extends string> {
  #channels: Partial<Record<T, Subject<string>>> = {};

  setSearch(channel: T, value: string) {
    this.#getChannel(channel).next(value);
  }

  getSearch$(channel: T) {
    return this.#getChannel(channel).asObservable();
  }

  #getChannel(channel: T): Subject<string> {
    if (!this.#channels[channel]) {
      this.#channels[channel] = new BehaviorSubject<string>('');
    }

    return this.#channels[channel];
  }

  reset(channel: T) {
    this.#getChannel(channel).next('');
  }

  resetAll() {
    Object.keys(this.#channels).forEach((channel) =>
      this.#getChannel(channel as T).next(''),
    );
  }
}
